export const DRAFT = "Draft";
export const SAVED = "Saved";
// Others??
